'use client'

import { useTracking } from '@marketplace-web/shared/event-tracker'
import { GO_TO_WALLET_URL } from 'constants/routes'
import { clickEvent } from '_libs/common/event-tracker/events'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import { useConversationContext } from '@marketplace-web/domain/core-conversation'
import {
  ConversationActionButton,
  ConversationActionProps,
} from '@marketplace-web/domain/conversation-action'

const GoToWallet = ({ primary, title, inverse, theme, size }: ConversationActionProps) => {
  const { transaction } = useConversationContext()
  const { track } = useTracking()

  const trackButtonClick = () => {
    track(
      clickEvent({
        target: ClickableElement.GoToMyBalance,
        targetDetails: transaction?.id.toString(),
      }),
    )
  }

  return (
    <ConversationActionButton
      primary={primary}
      text={title}
      size={size}
      inverse={inverse}
      theme={theme}
      url={GO_TO_WALLET_URL}
      onClick={trackButtonClick}
    />
  )
}

export default GoToWallet
